/**
 * Swiper dependencies
 *
 * @see https://swiperjs.com/get-started
 */
import { Swiper } from 'swiper';
// eslint-disable-next-line import/no-unresolved
import { Autoplay, Keyboard, Navigation } from 'swiper/modules';
/**
 * Initialize the slider.
 *
 * @param {Element} container HTMLElement.
 *
 * @return {Object} Returns initialized slider instance.
 *
 * @see https://swiperjs.com/swiper-api#parameters
 */
export function SwiperInit(container) {
	const parameters = {
		slidesPerView: 'auto',
		spaceBetween: 4,
		loop: false,
		autoHeight: true,
		calculateHeight: true,
		autoplay: false,
		initialSlide: 0,
		keyboard: true,
		modules: [Autoplay, Keyboard, Navigation],
		navigation: {
			nextEl: '.rlt-cat-list-swiper-button-next',
			prevEl: '.rlt-cat-list-swiper-button-prev',
		},
		simulateTouch: true,
	};

	return new Swiper(container, parameters);
}
